// extracted by mini-css-extract-plugin
module.exports = {"scrollOuter":"styles_scrollOuter__G_Fl7","scrollInner":"styles_scrollInner__RWftY","playIcon":"styles_playIcon__1rSeU"};